import { QuestionAnswer } from "./QuestionAnswer";
import { FileAnswer } from "./FileAnswer";
import { ConsentAnswer } from "./ConsentAnswer";
import { Form } from "./Form";

export class FormAnswer
{
  constructor() {
    this.questionAnswers = new Array<QuestionAnswer>();
    this.fileAnswers = new Array<FileAnswer>();
    this.consentAnswers = new Array<ConsentAnswer>();
  }
  formAnswerId: number;
  formId: number;
  recruitmentSourceGuid: string;
  questionAnswers: QuestionAnswer[];
  fileAnswers: FileAnswer[];
  consentAnswers: ConsentAnswer[];
  form: Form;
	}
